<div class='container' style="background-color:#4b4747;">

  <div class='row p-3'>
    <div class='col-lg-2 text-center'><button class='btn btn-success' (click)="addDay()">Add Day</button>
      <br>
      <hr>
      <span *ngFor="let item of allDays" (click)="showDay(item.index)">
        <div class='dayDiv'>Day {{item.index}}</div>
        <hr>
      </span>
    </div>
    <div class='col-lg-4 text-center'><button class="btn btn-success" (click)="open(addTopicModal)">+ Add
        Topic</button>
      <br>
      <hr>
      <div *ngIf="allDays[currentDay - 1].availableTopics > 0">
        <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
          <div *ngFor="let item of allDays[currentDay - 1].listOfTopics">
            <div class="example-box" cdkDrag *ngIf="item.deleted === false" (click)="setSelectedTopic(item.index)">
              {{item.title}}
              <span style='margin-left: auto; padding-right:10px;'>{{item.type}}</span>
              <button class="btn btn-success" (click)="open(moveTopicModal)">Move</button>&nbsp;
              <button (click)="deleteTopic(item.index)" class="btn btn-dark"><b>x</b></button>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div class='col-lg-6'  style='background-color: rgb(229, 227, 194); padding: 10px;'>
      <div id='notesContent'>
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
          <li [ngbNavItem]="1">
            <button type="button" class="btn btn-danger" ngbNavLink style="color:blanchedalmond;">Notes</button>
            <ng-template ngbNavContent>
              <hr>
              <angular-editor [(ngModel)]="topicNotesHtml" id='notesEditor' [config]="config"></angular-editor>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <button type = "button" class = "btn btn-success" ngbNavLink style="color:blanchedalmond;">Instructions</button>
            <ng-template ngbNavContent>
              <hr>
              <angular-editor [(ngModel)]="mentorNotesHtml" id='mentorNotesEditor' [config]="config"></angular-editor>
            </ng-template>
          </li>
        </ul>

        <div [ngbNavOutlet]="nav" class="mt-2"></div>
        <br>
        <button class='btn btn-success' style='float:right' (click)="saveNotes();">Save Notes</button>
        <br>
      </div>
      <div id='noContent' style='display:none;padding:5px' class='text-center' >
        <h2>No Topic Selected</h2>
        <hr>
      </div>
    </div>
  </div>
  <hr>
</div>


<ng-template #addTopicModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add Topic</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="topicTitle">Topic Title</label>
      <br>
      <input type="text" [(ngModel)]="newTopicTitle" class="form-control" />
      <br>
      <label for="topicType">Topic Type</label>
      <br>
      <select name="topicSelect" [(ngModel)]="newTopicType" class="form-control">
        <option *ngFor="let item of topicTypes" [value]="item">{{item}}</option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Add click');modalAddTopic();">Add</button>
  </div>
</ng-template>

<ng-template #moveTopicModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Move Topic</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="topicTitle">Move To Day : </label>
      <select [(ngModel)]="moveDay" name="daySelect" class="form-control">
        <option *ngFor="let item of allDays" [value]="item.index">{{item.index}}</option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Add click');moveTopic();">Move</button>
  </div>
</ng-template>